// src/lib/icons.ts
import {
  ChartLine,
  Shield,
  TrendingUp,
  Smartphone,
  Server,
  Brain,
  Laptop,
  Users,
  AlertTriangle,
  FileCheck,
  Radio,
  BarChart3,
  Zap,
  Bot,
  Landmark,
  ArrowRight,
  Briefcase,
  Mail,
  Phone,
  MapPin,
  Clock,
  ArrowUp,
  Linkedin,
  Facebook,
  Twitter,
  Copyright,
  CheckCircle,
  Trophy,
  ZapIcon,
  ShieldCheck,
  LandmarkIcon,
  Youtube,
  Plug,
  Instagram
} from "lucide-react";

export const iconMap = {
  ChartLine,
  Shield,
  TrendingUp,
  Smartphone,
  Server,
  Brain,
  Laptop,
  Users,
  AlertTriangle,
  FileCheck,
  Radio,
  BarChart3,
  Zap,
  Bot,
  Landmark,
  ArrowRight,
  Briefcase,
  Mail,
  Phone,
  MapPin,
  Clock,
  ArrowUp,
  Linkedin,
  Facebook,
  Twitter,
  Copyright,
  CheckCircle,
  Trophy,
  ZapIcon,
  ShieldCheck,
  LandmarkIcon,
  Youtube,
  Plug,
  Instagram
} as const;

export type IconName = keyof typeof iconMap;
